import type { ProjectTileViewModel } from '@rocco/ui/tile-project/view-models/project';

/**
 * Similar Projects page size by device, used for the SSR first page and every
 * "Load More" page alike so the offsets line up. One row wider than the grid
 * needs (3 desktop / 2 mobile columns): excluding the current project leaves a
 * ragged tail that the row-trim discards, so the extra row is what keeps three
 * full rows on screen from the first paint. Lives in a neutral (non-`.server`)
 * module so the client hook can import it too.
 */
export const SIMILAR_PROJECTS_PAGE_SIZE = { desktop: 12, mobile: 6 } as const;

export interface SimilarProjectsPage {
    projects: ProjectTileViewModel[];
    hasMore: boolean;
    totalCount: number;
}
